import React from 'react';
import usePartners from './usePartners';

export default function useSleepingPartners(state, network, schoolStart, schoolEnd, currentTimestamp) {
  return usePartners(state, network, schoolStart, schoolEnd, {
    sleepingStartingAt: {
      $lte: currentTimestamp
    },
    sleepingEndingAt: {
      $gte: currentTimestamp
    },
    inactive: false
  });
}
